/**
 * 値の表の幅。列が1〜3つの表が画面いっぱいに広がると、見出しと値が離れて対応を追いにくいため、内容の幅に合わせる。
 * 列の幅は表示モードと編集モードで同じにし、切り替えても並びが変わらないようにする。
 */

import type { ColumnDef } from '@/lib/credit-conversion-settings/tables';

export const fitContentSx = { width: 'fit-content', maxWidth: '100%' } as const;

export const tableSx = { width: 'auto' } as const;

/**
 * 数値の列は、保存できる最も長い値が入力欄に収まる幅。長い見出しは折り返す。
 * 最も長いのは、S3容量の単価と累進テーブルの超過分の単価の21文字。数字は字によって幅が違うので、最も幅の広い0を並べても収まる幅にしている。
 */
export function columnWidthSx(column: ColumnDef) {
  const width = column.kind === 'number' ? 290 : 180;
  return { width, minWidth: width, maxWidth: width };
}
